import React, { useEffect } from 'react';
import { Box } from '@chakra-ui/react';

interface FlowiseChatbotProps {
  chatflowid: string;
  apiHost: string;
  theme?: any; // Using any for theme to avoid complex type definitions
  chatflowConfig?: Record<string, any>;
}

const FlowiseChatbot: React.FC<FlowiseChatbotProps> = ({
  chatflowid,
  apiHost,
  theme,
  chatflowConfig,
}) => {
  useEffect(() => {
    const initChatbot = async () => {
      try {
        // Dynamically import the Flowise embed script
        const { default: Chatbot } = await import('flowise-embed/dist/web');

        // Initialize the chatbot
        Chatbot.init({
          chatflowid,
          apiHost,
          theme,
          chatflowConfig,
        });

        console.log('Flowise chatbot initialized successfully');
      } catch (error) {
        console.error('Failed to initialize Flowise chatbot:', error);
      }
    };

    // Only initialize if we have the required config
    if (chatflowid && apiHost) {
      initChatbot();
    }

    // Cleanup function
    return () => {
      // Remove chatbot elements if needed
      const chatbotElements = document.querySelectorAll('[id^="flowise-"]');
      chatbotElements.forEach(element => element.remove());
    };
  }, [chatflowid, apiHost, theme, chatflowConfig]);

  // The chatbot renders itself, so we return an empty container
  return <Box id="flowise-chatbot-container" />;
};

export default FlowiseChatbot;
